import { CalendarGridItemVariant } from '../../../../../constants/calendarGrid'
import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { getCalendarGridTimeRangeLabel } from '../../../CalendarGrid.utils.time'
import { getCalendarGridGroupStyle } from '../../CalendarGridWeek.utils'
import { CalendarGridWeekBlock } from '../../CalendarGridWeekBlock'
import { getCalendarGridItemOffsets } from '../CalendarGridWeekColumn.utils'

import * as styles from './CalendarGridWeekDropPreview.module.css'

function CalendarGridWeekDropPreview({ firstHour, item = EMPTY_OBJECT }) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { end, start, title } = item

  return (
    <CalendarGridWeekBlock
      className={styles.CalendarGridWeekDropPreview}
      style={getCalendarGridGroupStyle(
        getCalendarGridItemOffsets({ firstHour, item, locale, timezone })
      )}
      timeLabel={getCalendarGridTimeRangeLabel({
        end,
        locale,
        start,
        timezone,
      })}
      title={title}
      variant={CalendarGridItemVariant.free}
    />
  )
}

export default CalendarGridWeekDropPreview
